<template>
    <div>
        <div class="mb-4">
            <div v-if="merken && merken.length" class="head" data-target="#merken" data-toggle="collapse" v-bind:aria-expanded="showBrand()">
                <h4>Merken <span class="icon-arrow"></span></h4>
            </div>
            <div v-bind:class="showBrand2()" id="merken">
                <ul>
                    <li class="filter-list" v-for="merk in merken" v-bind:key="merk.MerkID">
                        <input type="checkbox" v-model="checkedBrands" class="pixel-checkbox" v-bind:value="merk.MerkID" /><label>{{ merk.MerkNaam }}</label>
                    </li>
                </ul>
            </div>
        </div>
        <div v-for="categoriefilter in categoriefilters" v-bind:key="categoriefilter.FilterID" class="mb-4">
            <div class="head" v-bind:data-target="accordionTarget(categoriefilter.FilterID)" data-toggle="collapse" v-bind:aria-expanded="showFilter(categoriefilter.CategorieFilterOpties)">
                <h4>{{categoriefilter.Naam}} <span class="icon-arrow"></span></h4>
            </div>
            <div v-bind:class="showFilter2(categoriefilter.CategorieFilterOpties)" v-bind:id="accordionId(categoriefilter.FilterID)">
                <ul>
                    <li class="filter-list" v-for="optie in categoriefilter.CategorieFilterOpties" v-bind:key="optie.OptieID">
                        <input type="checkbox" v-model="checkedOpties" class="pixel-checkbox" v-bind:value="optie.OptieID" /><label>{{ optie.Naam }}</label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    //data-parent="#accordion"  add to id="merken"
    export default {
    name: 'ProductFilter',
        methods: {
            accordionTarget(filterId) {
                return "#acc" + filterId;
            },
            accordionId(filterId) {
                return "acc" + filterId;
            },
            showFilter(categoriefilteropties) {
                for (var i=0;i<this.checkedOpties.length;i++) {
                    for (var j=0;j<categoriefilteropties.length;j++) {
                        if (categoriefilteropties[j].OptieID == this.checkedOpties[i])
                            return "true";
                    }
                }
                return "true";// "false";
            },
            showFilter2(categoriefilteropties) {
                if (this.showFilter(categoriefilteropties) == "true")
                    return "collapse show";
                else
                    return "collapse show";//show verwijderen indien ingeklapt
            },
            showBrand() {
                for (var i=0;i<this.checkedBrands.length;i++) {
                    for (var j=0;j<this.merken.length;j++) {
                        if (this.merken[j].MerkID == this.checkedBrands[i])
                            return "true";
                    }
                }
                return "true";// "false";
            },
            showBrand2() {
                if (this.showBrand() == "true")
                    return "collapse show";
                else
                    return "collapse show";//show verwijderen indien ingeklapt
            }
        },
    created() {
        var queryArray = window.location.search.replace('?', '').split('&');
        if (queryArray.length > 0) {
            for (var q=0; q<queryArray.length; q++) {
                var qArr = queryArray[q].split('=')
                if (qArr[0] == 'brnd') {
                    var brndval = qArr[1].split(',');
                    for (var i=0; i<brndval.length; i++)
                        this.checkedBrands.push(brndval[i]);
                }
                if (qArr[0] == 'fltr') {
                    var fltrval = qArr[1].split(',');
                    for (var j=0; j<fltrval.length; j++)
                        this.checkedOpties.push(fltrval[j]);
                }
                if (qArr[0] == 'Pg')
                    this.currentPage = parseInt(qArr[1]);
            }
        }
    },
    computed: {
        merken() {
            return this.$store.state.filtertree.Merken;
        },
        categoriefilters() {
            return this.$store.state.filtertree.CategorieFilters;
        },
        checkedBrands: {
            get() {
                return this.$store.state.checkedFilter.checkedBrands;
            },
            set(value) {
                this.$store.state.currentPage = 1;
                this.$store.dispatch('changeCheckedBrands', value);
                this.$store.dispatch('fetchProducts', this.$store.state.checkedFilter);
            }
        },
        checkedOpties: {
            get() {
                return this.$store.state.checkedFilter.checkedOpties;
            },
            set(value) {
                this.$store.state.currentPage = 1;
                this.$store.dispatch('changeCheckedOpties', value);
                this.$store.dispatch('fetchProducts', this.$store.state.checkedFilter);
            }
        },
        currentPage: {
            get() {
                return this.$store.state.currentPage;
            },
            set(value) {
                this.$store.dispatch('changeCurrentPage', value);
            }
        }
    }
    }
</script>